import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
} from '@angular/router';
import { AuthService } from './auth.service';
import {
    getEmbedReturnUrl,
    isEmbedSession,
    resolveEmbedReturnUrl,
} from '../utils/embed-session';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authService.currentUserValue;
        if (currentUser) {
            // logged in so return true
            return true;
        }

        const isSSO = localStorage.getItem('isSSO') === 'true';

        // Embed iframe: never fall through to bare signin-callback with lost returnUrl → dashboard
        if (isEmbedSession()) {
            const returnUrl = resolveEmbedReturnUrl(getEmbedReturnUrl() || state.url);
            if (isSSO) {
                this.router.navigate(['/auth/signin-callback'], {
                    queryParams: { returnUrl, embed: '1' },
                    replaceUrl: true,
                });
            } else {
                // No local session — stay on embed handoff (credentials already stripped; show error there)
                this.router.navigate(['/auth/embed'], {
                    queryParams: { embed: '1', returnUrl },
                    replaceUrl: true,
                });
            }
            return false;
        }

        if (isSSO) {
            this.router.navigate(['/auth/signin-callback'], { queryParams: { returnUrl: state.url } });
            return false;
        }

        this.router.navigate(['/auth/sign-in'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
